// extracted by mini-css-extract-plugin
export default {"file":"FileCard_file__GJS87"};